import {
  Inserts,
  SingleItemResponse,
} from '../../configuratorData/slice/types';
import { ErpalApiRequestType } from './types';

export const erpalPayloadDTO = (
  data: SingleItemResponse[] | Inserts[],
): ErpalApiRequestType => {
  const array = data.map(item => {
    return { itemNumber: item.erpPartNumber, unitCode: 'PCE' };
  });

  return { items: array };
};
